import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
	HistoryToggleOff,
	Home,
	Inbox,
	Logout,
	Mail,
} from '@mui/icons-material';
import {
	Box,
	Divider,
	List,
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	SwipeableDrawer,
} from '@mui/material';

export default function SwipeableMenu({ drawerIsOpen, setDrawerIsOpen }) {
	const navigate = useNavigate();
	const toggleDrawer = () => (event) => {
		setDrawerIsOpen(!drawerIsOpen);
	};

	const logout = () => {
		setDrawerIsOpen(!drawerIsOpen);
		localStorage.removeItem('user');
		window.location.reload();
	};

	const menuList = [
		{ label: 'Inicio', path: '/', icon: <Home /> },
		{
			label: 'Historial de pedidos',
			path: '/orders-history',
			icon: <HistoryToggleOff />,
		},
		{ label: 'Clientes?', path: '', icon: '' },
		{ label: '', path: '', icon: '' },
	];

	const list = (anchor) => (
		<Box
			sx={{ width: { xs: '80vw', xsm: 300, md: 350 } }}
			role='presentation'
			onClick={toggleDrawer(!drawerIsOpen)}
			onKeyDown={toggleDrawer(!drawerIsOpen)}
		>
			<List>
				{menuList.map(({ label, path, icon }, index) => (
					<ListItem key={label} disablePadding>
						<ListItemButton
							onClick={() => {
								navigate(path);
								toggleDrawer(!drawerIsOpen);
							}}
						>
							<ListItemIcon>{icon}</ListItemIcon>
							<ListItemText primary={label} />
						</ListItemButton>
					</ListItem>
				))}
			</List>
			<Divider />

			<List
				sx={{
					position: 'absolute',
					bottom: 0,
					right: 0,
					left: 0,
				}}
			>
				<Divider />
				<ListItem disablePadding onClick={() => logout()}>
					<ListItemButton>
						<ListItemIcon>
							<Logout color='red' />
						</ListItemIcon>
						<ListItemText primary='Cerrar sesión' sx={{ color: 'red.main' }} />
					</ListItemButton>
				</ListItem>
			</List>
		</Box>
	);
	return (
		<SwipeableDrawer
			anchor='left'
			open={drawerIsOpen}
			onClose={() => setDrawerIsOpen(!drawerIsOpen)}
			onOpen={() => setDrawerIsOpen(!drawerIsOpen)}
			PaperProps={{
				sx: {
					borderRadius: '0px 80px 0px 0px !important',
				},
			}}
		>
			{list('left')}
		</SwipeableDrawer>
	);
}
